import { useEffect, useState } from "react";

import authorImage from "../../assets/gopal.jpg";

import threatHeaderImage from "../../assets/blog_images/threatModeling/Header.webp";
import picture1Image from "../../assets/blog_images/threatModeling/Picture1.png";
import picture3Image from "../../assets/blog_images/threatModeling/Picture3.png";
import picture5Image from "../../assets/blog_images/threatModeling/Picture5.png";
import picture6Image from "../../assets/blog_images/threatModeling/Picture6.png";

import sqlInjectionImage from "../../assets/blog_images/sqlInjection/sql_injection1.jpg";
import brokenAccessImage from "../../assets/blog_images/BrokenAccessControllAuthentication/brokenThumbnail.png";
import sessionImage from "../../assets/blog_images/sessionManagement/session1.png";

const SUPPORT_WHATSAPP_NUMBER = "919080432374";
const SUPPORT_MESSAGE = "Hi, I am Looking for Cyber Security Training";

function ThreatModeling() {
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [whatsappOpen, setWhatsappOpen] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    document.title = "Threat Modeling";

    function handleScroll() {
      setShowBackToTop(window.scrollY > 300);
    }

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function openWhatsAppChat() {
    const encoded = encodeURIComponent(SUPPORT_MESSAGE);
    const waMe = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encoded}`;

    window.open(waMe, "_blank", "noopener,noreferrer");
  }

  function openWhatsAppAppFallback() {
    const encoded = encodeURIComponent(SUPPORT_MESSAGE);
    const deepLink = `whatsapp://send?phone=${SUPPORT_WHATSAPP_NUMBER}&text=${encoded}`;
    const webLink = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encoded}`;

    window.location.href = deepLink;

    setTimeout(() => {
      window.open(webLink, "_blank", "noopener,noreferrer");
    }, 700);
  }

  return (
    <main className="overflow-x-hidden bg-white">
      <section className="w-full max-w-5xl px-4 py-10 mx-auto overflow-x-hidden bg-white">
        <article className="article post tag-hackthebox image-small">
          <header className="article-header gh-canvas">
            <div className="mb-2 article-tag post-card-tags">
              <span className="post-card-primary-tag">
                <a href="" className="text-blue-600">
                  ThreatModeling
                </a>
              </span>
            </div>

            <h1 className="mb-4 text-4xl font-semibold article-title">
              Beginner&apos;s Practical Guide to Threat Modeling : Everything You
              Need to Know Get Started
            </h1>

            <p className="mb-6 text-gray-800 article-excerpt">
              Threat modeling is a structured approach to identifying,
              evaluating, and addressing potential security threats in a system
              before they can be exploited. It helps developers, architects, and
              security professionals think like attackers, allowing them to
              pinpoint weaknesses in design, architecture, or implementation
              early in the development lifecycle.
            </p>

            {/* Article Author Info */}
            <div className="flex flex-col items-start justify-between mb-6 sm:flex-row sm:items-center">
              {/* Left Section */}
              <div className="flex items-start gap-4">
                <img
                  className="w-12 h-12 rounded-full"
                  src={authorImage}
                  alt="gopala krishna"
                />

                <div>
                  <h4 className="text-lg font-semibold">
                    <a href="">Gopala Krishna</a>
                  </h4>

                  <div className="text-sm font-medium text-gray-500">
                    <time dateTime="2025-05-03">May 22, 2025</time>
                    <span className="ml-1">• 10 min read</span>
                  </div>
                </div>
              </div>

              {/* Right Section: Share Icon */}
              <button
                type="button"
                onClick={() => setShareModalOpen(true)}
                className="mt-5 ml-2 text-2xl text-gray-700 cursor-pointer font-bild hover:text-black"
              >
                {/* Share Icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-8 h-8 fill-current"
                  viewBox="0 0 24 24"
                >
                  <path
                    fillRule="evenodd"
                    d="M15.218 4.931a.4.4 0 0 1-.118.132l.012.006a.45.45 0 0 1-.292.074.5.5 0 0 1-.3-.13l-2.02-2.02v7.07c0 .28-.23.5-.5.5s-.5-.22-.5-.5v-7.04l-2 2a.45.45 0 0 1-.57.04h-.02a.4.4 0 0 1-.16-.3.4.4 0 0 1 .1-.32l2.8-2.8a.5.5 0 0 1 .7 0l2.8 2.79a.42.42 0 0 1 .068.498m-.106.138.008.004v-.01zM16 7.063h1.5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-11c-1.1 0-2-.9-2-2v-10a2 2 0 0 1 2-2H8a.5.5 0 0 1 .35.15.5.5 0 0 1 .15.35.5.5 0 0 1-.15.35.5.5 0 0 1-.35.15H6.4c-.5 0-.9.4-.9.9v10.2a.9.9 0 0 0 .9.9h11.2c.5 0 .9-.4.9-.9v-10.2c0-.5-.4-.9-.9-.9H16a.5.5 0 0 1 0-1"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </button>
            </div>

            {/* Share Modal */}
            {shareModalOpen && (
              <div
                className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-50"
                onClick={(event) => {
                  if (event.target === event.currentTarget) {
                    setShareModalOpen(false);
                  }
                }}
              >
                <div className="p-6 text-black bg-gray-200 rounded-md w-80">
                  <h2 className="mb-4 text-lg font-semibold">
                    Share this article
                  </h2>

                  <div className="flex items-center justify-around">
                    {/* X / Twitter */}
                    <a
                      href="https://twitter.com/intent/tweet?text=https://www.practicalinfosec.com/sqlInjection"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-blue-500"
                    >
                      <svg className="w-10 h-10 fill-current" viewBox="0 0 24 24">
                        <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53A4.48 4.48 0 0 0 22.43.36a9 9 0 0 1-2.83 1.08A4.52 4.52 0 0 0 16.11 0c-2.63 0-4.64 2.24-4.04 4.79A12.94 12.94 0 0 1 1.64 1.14a4.52 4.52 0 0 0-.61 2.27 4.5 4.5 0 0 0 2 3.75 4.41 4.41 0 0 1-2.06-.56v.06a4.53 4.53 0 0 0 3.63 4.43 4.52 4.52 0 0 1-2.04.08 4.53 4.53 0 0 0 4.22 3.14A9.05 9.05 0 0 1 0 19.54a12.93 12.93 0 0 0 7 2.05c8.4 0 13-7.5 12.68-14.23A9.18 9.18 0 0 0 23 3z" />
                      </svg>
                    </a>

                    {/* Facebook */}
                    <a
                      href="https://www.facebook.com/sharer/sharer.php?u=https://www.practicalinfosec.com/sqlInjection"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-blue-700"
                    >
                      <svg className="w-8 h-8 fill-current" viewBox="0 0 24 24">
                        <path d="M22.675 0h-21.35C.592 0 0 .593 0 1.326v21.348C0 23.408.592 24 1.325 24H12.82V14.708h-3.293V11.17h3.293V8.413c0-3.26 1.986-5.038 4.89-5.038 1.39 0 2.585.104 2.933.15v3.4l-2.013.001c-1.577 0-1.883.75-1.883 1.85v2.43h3.766l-.491 3.538h-3.275V24h6.42C23.408 24 24 23.408 24 22.675V1.325C24 .593 23.408 0 22.675 0z" />
                      </svg>
                    </a>

                    {/* LinkedIn */}
                    <a
                      href="https://www.linkedin.com/sharing/share-offsite/?url=https://www.practicalinfosec.com/sqlInjection"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-blue-600"
                    >
                      <svg className="w-8 h-8 fill-current" viewBox="0 0 24 24">
                        <path d="M20.447 20.452H17.24V14.8c0-1.345-.025-3.078-1.879-3.078-1.88 0-2.168 1.464-2.168 2.976v5.753h-3.207V9h3.076v1.561h.043c.429-.811 1.476-1.666 3.036-1.666 3.246 0 3.844 2.137 3.844 4.917v6.64zM5.337 7.433c-1.034 0-1.873-.839-1.873-1.874 0-1.034.839-1.873 1.873-1.873 1.036 0 1.875.839 1.875 1.873s-.839 1.874-1.875 1.874zM6.789 20.452H3.885V9h2.904v11.452zM22.225 0H1.771C.791 0 0 .77 0 1.723v20.555C0 23.23.79 24 1.771 24h20.451C23.21 24 24 23.23 24 22.278V1.723C24 .77 23.21 0 22.225 0z" />
                      </svg>
                    </a>
                  </div>

                  <button
                    type="button"
                    onClick={() => setShareModalOpen(false)}
                    className="block mx-auto mt-4 text-sm text-gray-600 underline hover:text-black"
                  >
                    Close
                  </button>
                </div>
              </div>
            )}

            <figure className="mb-6 text-center article-image">
              <img
                src={threatHeaderImage}
                alt="ThreatModeling"
                className="object-cover w-3/4 mx-auto rounded-lg"
              />
            </figure>
          </header>

          <section className="gh-content gh-canvas">
            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              OWASP 2021 - Insecure Design
            </h2>

            <p className="mb-4">
              OWASP had emphasized Insecure design in its 2021 OWASP top 10.
              which refers to flaws in the architecture and design of systems.
              Insecure design issues often require more fundamental changes
              within the product which are external to the code Architectural
              and technology stack changes, Underlying OS, System hardening,
              Insecure configurations, Ineffective controls. Addressing these
              types of issues in a live production environment with public
              access can be extremely costly.
            </p>

            <figure className="mb-6 article-image">
              <img
                src={picture1Image}
                alt="Wrong design"
                className="object-cover w-3/4 mx-auto rounded-lg"
              />
            </figure>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              Threat Modeling : Shift-left security
            </h2>

            <p className="mb-4">
              To address Insecure design issues, OWASP recommends threat
              modeling, which is a proactive approach to security that involves
              identifying potential threats and vulnerabilities in software
              systems early in the development process. By integrating threat
              modeling into the Software Development Life Cycle SDLC,
              organizations can achieve shift-left security, which means
              addressing security concerns earlier in the development process
              rather than waiting until later stages or post-deployment.
            </p>

            <figure className="mb-6 article-image">
              <img
                src={picture3Image}
                alt="Sql Injection"
                className="w-full rounded-lg"
              />
            </figure>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              What & Why ?
            </h2>

            <h2 id="network-scan" className="mb-4 text-2xl font-semibold">
              What actually is threat modeling?
            </h2>

            <p className="mb-4">
              Threat modeling is a systematic approach aims to identify the
              attacks a system must resist and defenses that will bring the
              system to desired defensive state. It had been identified as best
              “return of investment” with respect to identifying and mitigating
              security issue early in the SDLC.
            </p>

            <h2 id="network-scan" className="mb-4 text-2xl font-semibold">
              Why threat modeling should be adopted?
            </h2>

            <p className="mb-4">
              No Scan, Manual PT or code review identify the Design &
              Implmentation flaws
            </p>

            <p className="mb-4">
              Ex: In most of the data breached organizations Following security
              practices Unable to identify intital access attempts, Laterval
              movements, and data exfiltration technicis with the traidtional
              assessment approach, nor there is information recorded to traceout
              actual threat actor.
            </p>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              When & How?
            </h2>

            <h2 id="network-scan" className="mb-4 text-2xl font-semibold">
              When should threat modeling be conducted??
            </h2>

            <p className="mb-4">
              Threat modeling can be conducted both for existing and new
              products. It is recommended that threat modeling should be
              conducted early in the planning or designing phases of SDLC and
              then can be refined throughout the life cycle of product
              development.
            </p>

            <h2 id="network-scan" className="mb-4 text-2xl font-semibold">
              How is the threat modeling process carried out??
            </h2>

            <p className="mb-4">
              There are various methodologies and frameworks for conducting
              threat modeling, including{" "}
              <strong>STRIDE, DREAD, and PASTA, among others..</strong>
            </p>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              What is not considered
            </h2>

            <h2 id="network-scan" className="mb-4 text-2xl font-semibold">
              What is not considered as threat modeling
            </h2>

            <p className="mb-4">
              Several activities and practices are often mistaken for threat
              modeling but do not constitute threat modeling in the strict sense.
              Here’s what is not considered threat modeling in DevSecOps:
            </p>

            <p className="mb-4">
              <strong>Code review -</strong> Code reviews focus on identifying
              issues in existing code base, whereas threat modeling considers
              the system’s architecture, data flow, and potential attack vectors
            </p>

            <p className="mb-4">
              <strong>Penetration testing -</strong> PT is a reactive process
              addressing existing issues, while threat modeling is proactive
              activity aimed at preventing potential issues
            </p>

            <p className="mb-4">
              <strong>Compliance audits -</strong> Compliance audits address
              existing policies,standards and controls, while threat modeling is
              a proactive approach aimed at eliminating misconfigurations &
              potential issues.
            </p>

            <div className="mb-6 overflow-x-auto">
              <table className="min-w-full mt-4 border border-collapse border-gray-300 table-auto">
                <thead>
                  <tr className="text-white bg-gray-800">
                    <th className="px-4 py-2 text-center border border-gray-300">
                      Characteristics
                    </th>
                    <th className="px-4 py-2 text-center border border-gray-300">
                      Proactive
                    </th>
                    <th className="px-4 py-2 text-center border border-gray-300">
                      Reactive
                    </th>
                  </tr>
                </thead>

                <tbody className="text-gray-700 bg-white">
                  <tr>
                    <td className="px-4 py-2 font-semibold border border-gray-300">
                      Objective
                    </td>
                    <td className="px-4 py-2 font-semibold border border-gray-300">
                      Prevent security issues before they occur, proactive
                      measures help in building secure systems from ground
                      level.
                    </td>
                    <td className="px-4 py-2 font-semibold border border-gray-300">
                      Respond to and resolve security issues after they occur,
                      reactive measures emerging threats are effectively managed
                    </td>
                  </tr>

                  <tr className="bg-gray-50">
                    <td className="px-4 py-2 font-semibold border border-gray-300">
                      Focus
                    </td>
                    <td className="px-4 py-2 font-semibold border border-gray-300">
                      Early identification and mitigation of potential threats
                    </td>
                    <td className="px-4 py-2 font-semibold border border-gray-300">
                      Monitor, detect, respond and remediate security incidents.
                    </td>
                  </tr>

                  <tr>
                    <td className="px-4 py-2 font-semibold border border-gray-300">
                      Stages and activities
                    </td>
                    <td className="px-4 py-2 font-semibold border border-gray-300">
                      Threat modeling, Secure design, CI/CD Security, SAST
                    </td>
                    <td className="px-4 py-2 font-semibold border border-gray-300">
                      DAST, Monitoring, Incident response, security patching
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              Prerequisites
            </h2>

            <p className="mb-4">
              <strong>Architecture - </strong>Architecture diagram, Component
              level diagram, Data flow, Network/Deployment diagram
            </p>

            <p className="mb-4">
              <strong>Technology stack - </strong> Web, app, DB server, API and
              open source framework products and version information
            </p>

            <p className="mb-4">
              <strong>Functionalities & User story - </strong> Login &
              Registration, User roles & previleges, Input fields, Data
              management CRUD, Business logics, File uploads, Third party
              integrations Live chats.
            </p>

            <p className="mb-4">
              <strong>Existing Security Controls - </strong> Authentication,
              Authroization, Session, Input sanitization.
            </p>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              Methodology & Tools
            </h2>

            <p className="mb-4">
              <strong>Methodology - STRIDE</strong>
            </p>

            <p className="mb-4">
              <strong>Security Frameworks - OWASP, CWE, CVE, MITRE Attack</strong>
            </p>

            <p className="mb-4">
              <strong>Tool - Threat dragon, Microsoft Threat modeling tool</strong>
            </p>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              Project Deliverables
            </h2>

            <ul className="space-y-2 text-gray-800 list-inside">
              <li className="ml-6">1. List of possible threats</li>
              <li className="ml-6">
                2. List of second and third order threats Ex:otp bypass, JWT
              </li>
              <li className="ml-6">
                3. List of mitigations and recommendations
              </li>
              <li className="ml-6">
                4. Priotitized list of threats Based on the likeli hood *
                business impact
              </li>
              <li className="mb-4 ml-6">5. Best practices</li>
            </ul>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              Threat Modeling : Phases
            </h2>

            <p className="mb-4">
              Threat modeling for new products should be conducted across each
              SDLC phase of product development which includes
            </p>

            <ul className="space-y-2 text-gray-800 list-inside">
              <li className="ml-6">1. Planning</li>
              <li className="ml-6">2. Requirement analysis</li>
              <li className="ml-6">3. Design</li>
              <li className="ml-6">4. Implementation</li>
              <li className="mb-4 ml-6">5. Testing</li>
              <li className="mb-4 ml-6">6. Deployment</li>
            </ul>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              STRIDE MODEL
            </h2>

            <p className="mb-4">
              STRIDE threat model is a framework used to identify and categorize
              potential security threats in a system. The acronym STRIDE stands
              for:
            </p>

            <div className="mb-6 overflow-x-auto">
              <table className="min-w-full mt-4 border border-collapse border-gray-300 table-auto">
                <thead>
                  <tr className="text-white bg-gray-800">
                    <th className="px-4 py-2 text-center border border-gray-300">
                      STRIDE Model
                    </th>
                    <th className="px-4 py-2 text-center border border-gray-300">
                      Security Mapping
                    </th>
                  </tr>
                </thead>

                <tbody className="text-gray-700 bg-white">
                  <tr>
                    <td className="px-4 py-2 font-semibold text-center border border-gray-300">
                      Spoofing
                    </td>
                    <td className="px-4 py-2 font-semibold text-center border border-gray-300">
                      Authentication
                    </td>
                  </tr>

                  <tr className="bg-gray-50">
                    <td className="px-4 py-2 font-semibold text-center border border-gray-300">
                      Tampering
                    </td>
                    <td className="px-4 py-2 font-semibold text-center border border-gray-300">
                      Integrity
                    </td>
                  </tr>

                  <tr className="bg-gray-50">
                    <td className="px-4 py-2 font-semibold text-center border border-gray-300">
                      Reoudiation
                    </td>
                    <td className="px-4 py-2 font-semibold text-center border border-gray-300">
                      Logging & Monitoring
                    </td>
                  </tr>

                  <tr className="bg-gray-50">
                    <td className="px-4 py-2 font-semibold text-center border border-gray-300">
                      Information Disclosure
                    </td>
                    <td className="px-4 py-2 font-semibold text-center border border-gray-300">
                      Confidentiality
                    </td>
                  </tr>

                  <tr className="bg-gray-50">
                    <td className="px-4 py-2 font-semibold text-center border border-gray-300">
                      Denail of Service
                    </td>
                    <td className="px-4 py-2 font-semibold text-center border border-gray-300">
                      Availability
                    </td>
                  </tr>

                  <tr className="bg-gray-50">
                    <td className="px-4 py-2 font-semibold text-center border border-gray-300">
                      Elevation of Privileges
                    </td>
                    <td className="px-4 py-2 font-semibold text-center border border-gray-300">
                      Authorization
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              Threat Modeling : Procedure
            </h2>

            <h2 id="network-scan" className="mb-4 text-2xl font-semibold">
              What are the steps involved in conducting threat modeling?
            </h2>

            <ul className="space-y-2 text-gray-800 list-inside">
              <li className="ml-6">
                1. Examine the architecture and its components in detail.
              </li>
              <li className="ml-6">
                2. Gain insight into the implemented functions, features, and
                business logic.
              </li>
              <li className="ml-6">
                3. Create a Data Flow Diagram based on the information gathered
                in each phase.
              </li>
              <li className="ml-6">4. Flag threats based on DFD.</li>
              <li className="mb-4 ml-6">
                5. Create a list of threats and map countermeasures.
              </li>
              <li className="mb-4 ml-6">6. Evaluate the results.</li>
            </ul>

            <figure className="mb-6 article-image">
              <img
                src={picture5Image}
                alt="Sql Injection"
                className="object-cover mx-auto rounded-lg"
              />
            </figure>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              Threat Modeling : Steps in Sequence
            </h2>

            <h2 id="network-scan" className="mb-4 text-2xl font-semibold">
              Decomposing the application for Threat modeling
            </h2>

            <ul className="mb-4 space-y-2 text-gray-800 list-inside">
              <li className="ml-6">
                <strong>Step 1 :</strong> Identify External dependencies - Refer
                to architectural & infra components, which are external to code
                and list them down.
              </li>

              <li className="ml-6">
                <strong>Step 2 :</strong> Identify Assets - Refers to things
                that the attacker is interested in, credentials, PII, sensitive
                data part of the application and list them down.
              </li>

              <li className="ml-6">
                <strong>Step 3 :</strong> Identify Entry points - Interface
                where attackers can submit malicious content Input
                fields/parameters and list them down.
              </li>

              <li className="ml-6">
                <strong>Step 4 :</strong> Identify Exit points - Where submitted
                data leaves the system Dynamically reflected data into web page
                and list them down.
              </li>

              <li className="ml-6">
                <strong>Step 5 :</strong> Identify trust boundaries - Represents
                access rights and privileges granted to various components,
                entities or systems within the system architecture and list them
                down.
              </li>
            </ul>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              Threat Modeling : Data Flow Diagram
            </h2>

            <figure className="mb-6 article-image">
              <img
                src={picture6Image}
                alt="Sql Injection"
                className="w-full rounded-lg lg:h-150"
              />
            </figure>

            <h2 id="network-scan" className="mb-6 text-4xl font-semibold">
              Mapping threats and mitigations
            </h2>

            <div className="mb-6 overflow-x-auto">
              <table className="min-w-full mt-4 border border-collapse border-gray-300 table-auto">
                <tbody className="text-gray-700 bg-white">
                  <tr>
                    <td className="px-4 py-2 font-semibold text-center border border-gray-300">
                      Application
                    </td>
                  </tr>

                  <tr className="bg-gray-50">
                    <td className="px-4 py-2 font-semibold text-center border border-gray-300">
                      Version
                    </td>
                  </tr>

                  <tr className="bg-white">
                    <td className="px-4 py-2 font-semibold text-center border border-gray-300">
                      Application Description
                    </td>
                  </tr>

                  <tr className="bg-gray-50">
                    <td className="px-4 py-2 font-semibold text-center border border-gray-300">
                      Author
                    </td>
                  </tr>

                  <tr className="bg-white">
                    <td className="px-4 py-2 font-semibold text-center border border-gray-300">
                      Participants
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="mb-4 overflow-x-auto">
              <table className="w-full mb-4 text-sm text-center border border-black table-auto">
                <thead>
                  <tr className="font-bold bg-cyan-200">
                    <th className="px-2 py-1 border border-black">
                      STRIDE Model
                    </th>
                    <th className="px-2 py-1 text-white bg-red-500 border border-black">
                      Feature/Functionality/Source
                    </th>
                    <th className="px-2 py-1 text-white bg-green-500 border border-black">
                      Strength
                    </th>
                    <th className="px-2 py-1 text-white bg-red-500 border border-black">
                      Weakness
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td className="px-2 py-1 border border-black">Spoofing</td>
                    <td className="px-2 py-1 border border-black">Login</td>
                    <td className="px-2 py-1 border border-black">Nill</td>
                    <td className="px-2 py-1 border border-black">No 2 MFA</td>
                  </tr>

                  <tr className="bg-gray-100">
                    <td className="px-2 py-1 border border-black">Tampering</td>
                    <td className="px-2 py-1 border border-black">
                      Input fields/parameters
                    </td>
                    <td className="px-2 py-1 border border-black">Nill</td>
                    <td className="px-2 py-1 border border-black">
                      No input validation
                    </td>
                  </tr>

                  <tr>
                    <td className="px-2 py-1 border border-black">
                      Repudiation
                    </td>
                    <td className="px-2 py-1 border border-black">
                      Audit trail
                    </td>
                    <td className="px-2 py-1 border border-black">Nill</td>
                    <td className="px-2 py-1 border border-black">
                      Inadequate logging
                    </td>
                  </tr>

                  <tr className="bg-gray-100">
                    <td className="px-2 py-1 border border-black">
                      Information Disclosure
                    </td>
                    <td className="px-2 py-1 border border-black">
                      Database records
                    </td>
                    <td className="px-2 py-1 border border-black">Nill</td>
                    <td className="px-2 py-1 border border-black">
                      No encryption
                    </td>
                  </tr>

                  <tr>
                    <td className="px-2 py-1 border border-black">
                      Denial of Service
                    </td>
                    <td className="px-2 py-1 border border-black">
                      Interface
                    </td>
                    <td className="px-2 py-1 border border-black">Nill</td>
                    <td className="px-2 py-1 border border-black">
                      No CDN/Waf
                    </td>
                  </tr>

                  <tr className="bg-gray-100">
                    <td className="px-2 py-1 border border-black">
                      Elevation of Privileges
                    </td>
                    <td className="px-2 py-1 border border-black">
                      Privilege management
                    </td>
                    <td className="px-2 py-1 border border-black">Nill</td>
                    <td className="px-2 py-1 border border-black">No LOP</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h2 id="network-scan" className="mb-6 text-4xl font-semibold">
              Mapping threats and mitigations
            </h2>

            <div className="mb-4 overflow-x-auto">
              <table className="w-full text-sm text-center border border-black table-auto">
                <thead>
                  <tr>
                    <th className="px-2 py-1 font-bold border border-black bg-cyan-200">
                      STRIDE Model
                    </th>
                    <th className="px-2 py-1 font-bold text-white bg-red-600 border border-black">
                      Feature/Functionality/Source
                    </th>
                    <th className="px-2 py-1 font-bold text-white bg-green-600 border border-black">
                      Strength
                    </th>
                    <th className="px-2 py-1 font-bold text-white bg-red-600 border border-black">
                      Weakness
                    </th>
                    <th className="px-2 py-1 font-bold bg-yellow-300 border border-black">
                      Threat 1
                    </th>
                    <th className="px-2 py-1 font-bold text-white bg-blue-400 border border-black">
                      Mitigation 1
                    </th>
                    <th className="px-2 py-1 font-bold text-white bg-pink-500 border border-black">
                      Risk
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr className="bg-white">
                    <td className="px-2 py-1 border border-black">Spoofing</td>
                    <td className="px-2 py-1 border border-black">Login</td>
                    <td className="px-2 py-1 border border-black">Nill</td>
                    <td className="px-2 py-1 border border-black">No 2 MFA</td>
                    <td className="px-2 py-1 border border-black">
                      Bruteforce
                    </td>
                    <td className="px-2 py-1 border border-black">2 FA</td>
                    <td className="px-2 py-1 font-bold text-white bg-red-600 border border-black">
                      High
                    </td>
                  </tr>

                  <tr className="bg-gray-100">
                    <td className="px-2 py-1 border border-black">Tampering</td>
                    <td className="px-2 py-1 border border-black">
                      Input fields/parameters
                    </td>
                    <td className="px-2 py-1 border border-black">Nill</td>
                    <td className="px-2 py-1 border border-black">
                      No input validation
                    </td>
                    <td className="px-2 py-1 border border-black">
                      XSS, SQL, XXE
                    </td>
                    <td className="px-2 py-1 border border-black">
                      Input sanitization
                    </td>
                    <td className="px-2 py-1 font-bold text-white bg-red-600 border border-black">
                      High
                    </td>
                  </tr>

                  <tr className="bg-white">
                    <td className="px-2 py-1 border border-black">
                      Repudiation
                    </td>
                    <td className="px-2 py-1 border border-black">
                      Audit trail
                    </td>
                    <td className="px-2 py-1 border border-black">Nill</td>
                    <td className="px-2 py-1 border border-black">
                      Inadequate logging
                    </td>
                    <td className="px-2 py-1 border border-black">
                      No trace of Security incidents
                    </td>
                    <td className="px-2 py-1 border border-black">
                      Log all security incidents
                    </td>
                    <td className="px-2 py-1 font-bold text-white bg-red-600 border border-black">
                      High
                    </td>
                  </tr>

                  <tr className="bg-gray-100">
                    <td className="px-2 py-1 border border-black">
                      Information Disclosure
                    </td>
                    <td className="px-2 py-1 border border-black">
                      Database records
                    </td>
                    <td className="px-2 py-1 border border-black">Nill</td>
                    <td className="px-2 py-1 border border-black">
                      No encryption
                    </td>
                    <td className="px-2 py-1 border border-black">
                      Data exfiltration
                    </td>
                    <td className="px-2 py-1 border border-black">
                      Enforce Encryption
                    </td>
                    <td className="px-2 py-1 font-bold text-white bg-red-600 border border-black">
                      High
                    </td>
                  </tr>

                  <tr className="bg-white">
                    <td className="px-2 py-1 border border-black">
                      Denial of Service
                    </td>
                    <td className="px-2 py-1 border border-black">
                      Interface
                    </td>
                    <td className="px-2 py-1 border border-black">Nill</td>
                    <td className="px-2 py-1 border border-black">
                      No CDN/Waf
                    </td>
                    <td className="px-2 py-1 border border-black">DOS</td>
                    <td className="px-2 py-1 border border-black">
                      Place CDN/WAF
                    </td>
                    <td className="px-2 py-1 font-bold text-white bg-red-600 border border-black">
                      High
                    </td>
                  </tr>

                  <tr className="bg-gray-100">
                    <td className="px-2 py-1 border border-black">
                      Elevation of Privileges
                    </td>
                    <td className="px-2 py-1 border border-black">
                      Privilege management
                    </td>
                    <td className="px-2 py-1 border border-black">Nill</td>
                    <td className="px-2 py-1 border border-black">No LOP</td>
                    <td className="px-2 py-1 border border-black">
                      Privilege escalation
                    </td>
                    <td className="px-2 py-1 border border-black">
                      Follow LOP
                    </td>
                    <td className="px-2 py-1 font-bold text-white bg-red-600 border border-black">
                      High
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              Mitigation order
            </h2>

            <p className="mb-4">
              <strong>Defense in Depth DID</strong> is a comprehensive
              cybersecurity strategy that employs multiple layers of security
              controls and measures to protect information and systems. The
              concept is akin to a multi-layered fortress where if one line of
              defense fails, additional layers continue to provide protection.
              This approach aims to ensure that a single point of failure does
              not compromise the entire system.
            </p>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              How can we assess the work
            </h2>

            <ul className="mb-4 space-y-2 text-gray-800 list-disc list-inside">
              <li className="ml-6">Is your DFD covering all the aspects</li>
              <li className="ml-6">Do you have list of potential threats</li>
              <li className="ml-6">
                Do you have mappings of countermeasures with identified threats
              </li>
              <li className="ml-6">
                Do you have list of ordered threats and mitigations
              </li>
              <li className="ml-6">
                Does all the stakeholder agree on Diagram and threats
              </li>
            </ul>
          </section>
        </article>
      </section>

      {/* Right Section: Share Icon */}
      <section className="w-full max-w-5xl px-4 mx-auto">
        <button
          type="button"
          onClick={() => setShareModalOpen(true)}
          className="mt-10 ml-2 text-2xl text-gray-700 cursor-pointer font-bild hover:text-black"
        >
          {/* Share Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-8 h-8 fill-current"
            viewBox="0 0 24 24"
          >
            <path
              fillRule="evenodd"
              d="M15.218 4.931a.4.4 0 0 1-.118.132l.012.006a.45.45 0 0 1-.292.074.5.5 0 0 1-.3-.13l-2.02-2.02v7.07c0 .28-.23.5-.5.5s-.5-.22-.5-.5v-7.04l-2 2a.45.45 0 0 1-.57.04h-.02a.4.4 0 0 1-.16-.3.4.4 0 0 1 .1-.32l2.8-2.8a.5.5 0 0 1 .7 0l2.8 2.79a.42.42 0 0 1 .068.498m-.106.138.008.004v-.01zM16 7.063h1.5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-11c-1.1 0-2-.9-2-2v-10a2 2 0 0 1 2-2H8a.5.5 0 0 1 .35.15.5.5 0 0 1 .15.35.5.5 0 0 1-.15.35.5.5 0 0 1-.35.15H6.4c-.5 0-.9.4-.9.9v10.2a.9.9 0 0 0 .9.9h11.2c.5 0 .9-.4.9-.9v-10.2c0-.5-.4-.9-.9-.9H16a.5.5 0 0 1 0-1"
              clipRule="evenodd"
            ></path>
          </svg>
        </button>
      </section>

      {/* Author Section */}
      <section className="max-w-5xl px-4 py-6 mx-auto mt-10 overflow-x-hidden rounded-lg">
        <div className="flex flex-col items-start gap-6 sm:flex-row">
          {/* Author Image */}
          <img
            src={authorImage}
            alt="Asman"
            className="object-cover w-24 h-24 rounded-lg"
          />

          {/* Author Info */}
          <div>
            <h3 className="mb-2 text-2xl font-semibold">
              Written by Gopala Krishna
            </h3>

            <p className="mb-3 text-gray-700">
              Application security engineer by profession and passionate
              security researcher and Author.
            </p>

            <p className="text-gray-500 text-md">
              Published on <time dateTime="2023-02-11">May 22, 2025</time> • 10
              min read
            </p>
          </div>
        </div>
      </section>

      <section className="py-12 text-black bg-white">
        <div className="max-w-screen-xl px-4 mx-auto sm:px-4 lg:px-8">
          <div className="grid grid-cols-1 gap-6 sm:gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {/* Blog Card 1 */}
            <article
              className="transition duration-300 ease-in-out transform blog-card"
              data-category="WebApplicationSecurity"
            >
              <div className="overflow-hidden transition bg-gray-100 shadow rounded-xl hover:shadow-lg">
                <a href="sql-injection" target="_blank" rel="noopener noreferrer">
                  <img
                    className="object-cover w-full h-48"
                    src={sqlInjectionImage}
                    alt="SQL Injection"
                  />
                </a>

                <div className="p-5">
                  <div className="mb-2 text-sm text-black">
                    WebApplicationSecurity
                  </div>

                  <h3 className="mb-2 text-xl font-semibold">
                    Understanding SQL Injection: A Web Security Threat
                  </h3>

                  <p className="mb-4 text-sm text-black">
                    SQL Injection is a critical security flaw that allows
                    attackers to manipulate SQL queries, risking data breaches or
                    full database control.
                  </p>

                  <div className="flex justify-between text-sm font-semibold text-gray-700">
                    <span>May 03, 2025</span>
                    <span>7 min read</span>
                  </div>
                </div>
              </div>
            </article>

            {/* Blog Card 2 */}
            <article
              className="transition duration-300 ease-in-out transform blog-card"
              data-category="OWASPTop10"
            >
              <div className="overflow-hidden transition bg-gray-100 shadow rounded-xl hover:shadow-lg">
                <a
                  href="broken-access-control-authentication"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="object-cover w-full h-48"
                    src={brokenAccessImage}
                    alt="Broken Access Control Authentication"
                  />
                </a>

                <div className="p-5">
                  <div className="mb-2 text-sm text-black">OWASPTop10</div>

                  <h3 className="mb-2 text-xl font-semibold">
                    Broken Access Control & Auth: A Security Breakdown
                  </h3>

                  <p className="mb-4 text-sm text-black">
                    Broken Access Control and Authentication vulnerabilities are
                    critical security flaws that allow unauthorized users to gain
                    access to restricted areas.
                  </p>

                  <div className="flex justify-between text-sm font-semibold text-gray-700">
                    <span>May 02, 2025</span>
                    <span>5 min read</span>
                  </div>
                </div>
              </div>
            </article>

            {/* Blog Card 1 */}
            <article
              className="transition duration-300 ease-in-out transform blog-card"
              data-category="WebApplicationSecurity"
            >
              <div className="overflow-hidden transition bg-gray-100 shadow rounded-xl hover:shadow-lg">
                <a
                  href="session-management"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="object-cover w-full h-48"
                    src={sessionImage}
                    alt="Session Management"
                  />
                </a>

                <div className="p-5">
                  <div className="mb-2 text-sm text-black">
                    WebApplicationSecurity
                  </div>

                  <h3 className="mb-2 text-xl font-semibold">
                    Secure Session Management: Best Practices & Techniques
                  </h3>

                  <p className="mb-4 text-sm text-black">
                    Session management is secure for user authentication in web
                    applications. Techniques to prevent session-related threats
                    like hijacking and fixation.
                  </p>

                  <div className="flex justify-between text-sm font-semibold text-gray-700">
                    <span>Apr 28, 2025</span>
                    <span>5 min read</span>
                  </div>
                </div>
              </div>
            </article>

            {/* Repeat your blog cards here (already responsive) */}
          </div>
        </div>
      </section>

      {/* WhatsApp Sticky Button */}
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          setWhatsappOpen((prev) => !prev);
        }}
        className="fixed z-50 p-3 px-4 text-white transition -translate-y-1/2 rounded-full shadow-lg cursor-pointer top-1/2 right-6 animate-blink hover:opacity-90 bg-gradient-to-r from-green-400 via-green-500 to-green-600"
        aria-label="Join WhatsApp"
      >
        <i className="text-4xl fa-brands fa-whatsapp"></i>
      </button>

      {/* WhatsApp Modal */}
      {whatsappOpen && (
        <div
          className="fixed z-50 p-4 transition-opacity duration-300 -translate-y-1/2 bg-white shadow-xl top-1/2 right-20 rounded-xl w-72 max-sm:right-4 max-sm:left-4 max-sm:w-auto"
          role="dialog"
          aria-modal="true"
          aria-labelledby="whatsappTitle"
        >
          {/* Close Button */}
          <button
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              setWhatsappOpen(false);
            }}
            className="absolute text-3xl text-gray-600 cursor-pointer top-2 left-4 hover:text-red-500"
            aria-label="Close"
          >
            &times;
          </button>

          <h2
            id="whatsappTitle"
            className="mt-6 mb-2 text-lg font-bold text-center text-gray-800"
          >
            Unsure about which course to choose?
          </h2>

          <p className="mb-3 text-sm text-center text-gray-700">
            Tap below to start a WhatsApp chat — we&apos;re here to help!
          </p>

          <div className="flex flex-col items-center gap-3">
            <button
              type="button"
              onClick={openWhatsAppChat}
              className="inline-flex items-center justify-center w-full gap-2 px-3 py-2 text-sm text-white transition bg-green-600 rounded-full hover:bg-green-700"
              aria-label="Chat Now on WhatsApp"
            >
              <i className="fa-brands fa-whatsapp"></i>
              Chat Now
            </button>

            <button
              type="button"
              onClick={openWhatsAppAppFallback}
              className="inline-flex items-center justify-center w-full gap-2 px-3 py-2 text-sm text-gray-800 transition border border-gray-200 rounded-full hover:bg-gray-50"
              aria-label="Open in WhatsApp App"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4 text-green-600"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M20.52 3.48A11.93 11.93 0 0012 .5C5.73.5.99 5.24.99 11.5c0 2.01.53 3.95 1.53 5.68L0 24l6.97-1.79c1.61.45 3.28.68 4.9.68 6.27 0 11.01-4.74 11.01-11 0-3.02-1.18-5.85-3.36-7.41zM12 21.5c-1.44 0-2.86-.34-4.14-.99l-.3-.15-4.14 1.06 1.15-3.98-.18-.31A8.12 8.12 0 013 11.5c0-4.97 4.06-9 9-9 2.41 0 4.66.94 6.36 2.64a8.95 8.95 0 012.64 6.36c0 4.97-4.06 9-9 9z" />
              </svg>
              Open in App
            </button>
          </div>
        </div>
      )}

      {/* Back to Top Button */}
      {showBackToTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed z-50 p-4 text-white transition bg-blue-700 rounded-lg shadow-lg cursor-pointer bottom-12 right-7 hover:bg-blue-700"
          aria-label="Back to top"
        >
          <i className="text-xl fa-solid fa-arrow-up"></i>
        </button>
      )}

      {/* Floating Call Button */}
      <a
        href="tel:+91-9080432374"
        className="fixed z-50 p-3 text-white transition rounded-md shadow-lg cursor-pointer bg-violet-600 bottom-60 right-7 hover:bg-green-700"
        aria-label="Call Us"
      >
        <i className="text-2xl fa-solid fa-phone"></i>
      </a>
    </main>
  );
}

export default ThreatModeling;